import React from "react";
import { HeartIcon } from "@heroicons/react/outline";
import Link from "next/link";
import AuthButtons from "./AuthButtons";
import { useSelector } from "react-redux";

const Bars3Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className="h-5 w-5"
  >
    <path
      fillRule="evenodd"
      d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10zm0 5.25a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75z"
      clipRule="evenodd"
    />
  </svg>
);

const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className="h-5 w-5"
  >
    <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
  </svg>
);

export default function NavButtons(props: any) {
  const isLoggedIn = useSelector((state: any) => state.auth.user);
  return (
    <>
      <div className="flex flex-row items-center w-fit">
        <div className="flex space-x-8">
          <div className="flex">
            <div className="hidden lg:flex">
              <button
                className="flex items-center p-2 text-sm font-medium text-gray-700 hover:text-blue-600"
                onClick={() => {
                  if (window != undefined) {
                    window.location.href =
                      process.env.NEXT_PUBLIC_BIDDER_URL || "";
                  }
                }}
              >
                Bidding{" "}
              </button>
            </div>
            <div className="flex lg:hidden">
              {isLoggedIn ? (
                <Link href="/dashboard/shortlisted">
                  <a className="flex items-center p-2 text-sm text-gray-400 hover:text-blue-700">
                    <HeartIcon height="20" width="20" className="ml-2" />
                  </a>
                </Link>
              ) : (
                <Link href="/login">
                  <a className="flex items-center p-0 md:p-2  text-sm text-gray-400 hover:text-blue-700">
                    <HeartIcon height="20" width="20" className="ml-2" />
                  </a>
                </Link>
              )}
            </div>
            {/* <Link href="/dashboard/shortlisted">
              <a className="flex items-center p-2 text-sm text-gray-400 hover:text-blue-700">
                Shortlisted{" "}
                <HeartIcon height="20" width="20" className="ml-2" />
              </a>
            </Link> */}
          </div>
        </div>
        <span
          className="mx-4 h-6 w-px bg-gray-200 lg:mx-4"
          aria-hidden="true"
        />
        <AuthButtons getStartActive={false} />
      </div>
      <div className="mt-1.5 lg:hidden">
        <span className="sr-only">Open main menu</span>
        <button
          type="button"
          onClick={() => {
            props.toggleSidebar();
          }}
        >
          {props.sidebar === true && <CloseIcon />}
          {props.sidebar === false && <Bars3Icon />}
        </button>
      </div>
    </>
  );
}
